import { Box } from "@mui/material";
import { Category } from "@/features/home";

export default function HomePage() {
	return (
		<Box
			sx={{
				height: "100%",
				width: "100%",
				display: "flex",
				flexDirection: "column",
				alignItems: "center",
				justifyContent: "center",
				py: 8,
			}}
		>
			<Category />
		</Box>
	);
}
